"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("FileManagerLib/Constants");

var _ImageUploadWithAsyncFilePicker = _interopRequireDefault(require("FileManagerLib/components/ImageUploadWithAsyncFilePicker"));

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var ImageUploadWithBrowse =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ImageUploadWithBrowse, _Component);

  function ImageUploadWithBrowse() {
    (0, _classCallCheck2.default)(this, ImageUploadWithBrowse);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImageUploadWithBrowse).apply(this, arguments));
  }

  (0, _createClass2.default)(ImageUploadWithBrowse, [{
    key: "renderFilePicker",
    value: function renderFilePicker(_ref) {
      var pickerType = _ref.pickerType,
          onClose = _ref.onClose,
          onSelect = _ref.onSelect;
      return _react.default.createElement(_Drawer.default, {
        pickerType: pickerType,
        onClose: onClose,
        onSelect: onSelect
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
      return _react.default.createElement(_ImageUploadWithAsyncFilePicker.default, (0, _extends2.default)({
        renderFilePicker: this.renderFilePicker
      }, rest), children);
    }
  }]);
  return ImageUploadWithBrowse;
}(_react.Component);

exports.default = ImageUploadWithBrowse;
ImageUploadWithBrowse.propTypes = {
  children: _react.PropTypes.node,
  iconName: _react.PropTypes.string,
  iconSize: _react.PropTypes.string,
  size: _react.PropTypes.string,
  pickerType: _react.PropTypes.oneOf(Object.keys(_Constants.PickerTypes)).isRequired,
  imageUrl: _react.PropTypes.string,
  uploadingFiles: _react.PropTypes.instanceOf(_immutable.default.OrderedMap),
  isOver: _react.PropTypes.bool,
  onChange: _react.PropTypes.func.isRequired,
  onUploadFile: _react.PropTypes.func,
  connectDropTarget: _react.PropTypes.func
};
ImageUploadWithBrowse.defaultProps = {
  pickerType: _Constants.PickerTypes.PANEL
};
module.exports = exports.default;